import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { OnboardEntry } from '@/features/onboarding';
import { normalizeInvitationCode } from '@/features/onboarding/utils/invitationCode';

const onboardSearchSchema = z.object({
  code: z.string().optional(),
});

export const Route = createFileRoute('/_public/onboard/')({
  validateSearch: zodValidator(onboardSearchSchema),
  beforeLoad: ({ search }) => {
    const normalizedCode = normalizeInvitationCode(search.code);

    if (!normalizedCode) {
      throw redirect({
        to: '/onboard/code',
        replace: true,
      });
    }

    if (search.code !== normalizedCode) {
      throw redirect({
        to: '/onboard',
        search: { code: normalizedCode },
        replace: true,
      });
    }
  },
  component: OnboardIndexRouteComponent,
});

function OnboardIndexRouteComponent() {
  const search = Route.useSearch();
  const normalizedCode = normalizeInvitationCode(search.code);

  if (!normalizedCode) return null;

  return <OnboardEntry code={normalizedCode} />;
}
